import { render, staticRenderFns } from "./CategoriasConceptos.vue?vue&type=template&id=5a945eea&scoped=true"
import script from "./CategoriasConceptos.vue?vue&type=script&lang=js"
export * from "./CategoriasConceptos.vue?vue&type=script&lang=js"
import style0 from "./CategoriasConceptos.vue?vue&type=style&index=0&id=5a945eea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a945eea",
  null
  
)

export default component.exports